module.exports = __webpack_public_path__ + "img/feature_5.c7c769c3.webp";